<template>
  <el-container>
    <el-main v-loading.fullscreen.lock="loading">
      <el-row type="flex" justify="center" align="center">
        <el-card shadow="never">
          <div class="title-wrapper">
            <span class="title">商户入驻</span>
          </div>
          <el-button type="primary" circle icon="el-icon-arrow-left" style="position: absolute; left: 20px; top: 20px;" @click="$router.go(-1)"></el-button>
          <el-steps v-show="active !== 3" :active="active" align-center>
            <el-step v-for="step in 2" :key="step"></el-step>
          </el-steps>
          <el-form ref="form" :model="form" :rules="rules" label-width="220px" label-position="left">
            <div v-show="active === 1">
              <div class="form-title">基础信息</div>
              <el-form-item label="公司全称" prop="name">
                <el-input v-model="form.name" maxlength="50"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="contact">
                <el-input v-model="form.contact" maxlength="12"></el-input>
              </el-form-item>
              <el-form-item label="联系方式" prop="contactPhone">
                <el-input v-model="form.contactPhone"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="captcha" class="inline">
                <el-input v-model="form.captcha" style="margin-right: 15px;flex: 1;"></el-input>
                <el-button type="primary" :disabled="disabledCaptcha" style="width: 120px;" @click="getCaptcha">{{captchaCount > 0 ? `${captchaCount}s` : '获取验证码'}}</el-button>
              </el-form-item>
              <el-form-item label="统一社会信用代码" prop="socialCreditCode">
                <el-input v-model="form.socialCreditCode"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email"></el-input>
              </el-form-item>
              <el-form-item label="公司地址" prop="location">
                <el-autocomplete v-model="form.location" :fetch-suggestions="onAutocompleteResult" :trigger-on-focus="false" style="width: 280px;">
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }}</div>
                  </template>
                </el-autocomplete>
              </el-form-item>
              <el-form-item label-width="0" class="item-center">
                <el-button type="primary" @click="next">下一步</el-button>
              </el-form-item>
            </div>
            <div v-show="active === 2">
              <div class="form-title">材料上传</div>
              <el-form-item ref="operateQualify" label-width="0" class="item-center" prop="operateQualify">
                <v-upload-media :limit="limit" :maxSize="maxSize" :accept="acceptType" :errMsg="errMsg" style="justify-content: center;" @change="handelFileChange">
                  <template slot="upload-text">
                    点击添加文件
                  </template>
                </v-upload-media>
                <div style="height: 20px;">{{fileName}}</div>
              </el-form-item>
              <el-form-item label-width="0" class="item-center">
                <p>请上传营业执照和运营资质证明，可上传jpg、pdf、rar格式的文件</p>
                <p>限传一个文件，若有多个文件，请打包后再上传</p>
              </el-form-item>
              <el-form-item label-width="0" class="item-center">
                <el-button type="primary" :disabled="loading" @click="() => active = 1">上一步</el-button>
                <el-button type="primary" :disabled="loading" @click="next">提交</el-button>
              </el-form-item>
            </div>
            <div v-show="active === 3">
              <div class="result">提交成功！</div>
              <el-form-item label-width="0" class="item-center">
                <p>恭喜您提交成功！</p>
                <p>我们会尽快联系您商讨相关入驻事宜。</p>
              </el-form-item>
            </div>
          </el-form>
        </el-card>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import UploadMedia from '@/components/upload-media'

export default {
  name: 'Apply',

  components: {
    'v-upload-media': UploadMedia,
  },

  data () {
    return {
      loading: false,
      active: 1,
      steps: new Map([
        [1, ['name', 'contact', 'contactPhone', 'socialCreditCode', 'captcha', 'email']],
        [2, ['operateQualify']]
      ]),
      form: {
        name: '',
        contact: '',
        contactPhone: '',
        socialCreditCode: '',
        email: '',
        location: '',
        operateQualify: '',
        captcha: '',
        uuid: ''
      },
      captchaCount: 0,
      requestingCatcha: false,
      fileName: '',
      rules: {
        name: [
          { required: true, message: '请填写公司全称', trigger: 'blur'}
        ],
        contact: [
          { required: true, message: '请填写联系人', trigger: 'blur'}
        ],
        contactPhone: [
          { required: true, message: '请填写联系方式', trigger: 'blur'},
          { pattern: this.$verification.isPhoneReg, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur'},
          { validator: (rule, value, callback) => this.form.uuid ? callback() : callback(new Error('请先获取验证码')), trigger: 'blur'}
        ],
        socialCreditCode: [
          { required: true, message: '请填写统一社会信用代码', trigger: 'blur'},
          { pattern: this.$verification.isSocialCreditCode, message: '请输入正确的统一社会信用代码', trigger: 'blur'}
        ],
        email: [
          { required: true, pattern: this.$verification.isEmail, message: '请输入正确的电子邮箱', trigger: 'blur'}
        ],
        operateQualify: [
          { required: true, message: '请上传营业执照和运营资质证明', trigger: 'blur'}
        ]
      },
      
      limit: 1,
      maxSize: 50 * 1024 * 1024,
      acceptType: ['.jpeg', '.jpg', '.pdf', '.zip', '.7z', '.gzip', '.tar', '.rar', '.svg'],
      errMsg: {
        overSize: '上传失败，文件大小不得超过50M'
      },

      placeSearch: null,
      searchOptions: {
        citylimit: true,
        city: '深圳',
        pageSize: 50
      }
    }
  },

  computed: {
    disabledCaptcha () {
      return this.captchaCount > 0 || this.requestingCatcha || !this.$verification.isPhoneReg.test(this.form.contactPhone)
    }
  },

  watch: {
    'form.contactPhone' () {
      this.form.captcha = ''
    }
  },

  mounted () {
    this.$nextTick(() => {
      !this.placeSearch && this.initSearchItem()
    })
  },

  methods: {
    initSearchItem () {
      this.placeSearch = new window.AMap.PlaceSearch(this.searchOptions)
    },

    next () {
      if (this.validateField()) {
        if (this.active === 2) {
          this.submit()
        } else {
          this.verificationCode().then(()=>{
            this.active += 1
          })
        }
      }
    },

    validateField () {
      let result = true
      this.$refs.form &&
      this.$refs.form.validateField(this.steps.get(this.active), err => {
        if (err) {
          result = false
        }
      })
      return result
    },
    
    submit () {
      const data =  new FormData()
      for(let key in this.form) {
        this.form[key] && data.append(key, this.form[key])
      }
      this.loading = true
      $post('/merchant/add', data, {
        timeout: 120000,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(r => {
        this.loading = false
        if (r && r.code === 200) {
          this.active += 1
        }
      })
    },

    handelFileChange (fileList) {
      if (fileList.length === 1) {
        this.form.operateQualify = fileList[0].raw
        this.fileName = fileList[0].name
        this.$refs.operateQualify && this.$refs.operateQualify.clearValidate()
      } else {
        this.form.operateQualify = ''
        this.fileName = ''
      }
    },

    onAutocompleteResult (str, cb) {
      if (str && str.length > 0) {
        this.placeSearch && this.placeSearch.search(str, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            cb(result.poiList.pois.map(ob => {
              ob.value = ob.name
              return ob
            }))
          }
        })
      } else {
        cb([])
      }
    },

    getCaptcha () {
      if (this.$verification.isPhoneReg.test(this.form.contactPhone)) {
        const data = {
          phoneNumber: this.form.contactPhone
        }
        this.requestingCatcha = true
        $post('/merchant/captcha-send', data).then(r => {
          this.requestingCatcha = false
          if (r && r.code === 200) {
            this.$message.success('短信已发送')
            this.captchaCount = 60
            this.form.uuid = r.data.uuid
            const interval = setInterval(() => {
              if (this.captchaCount > 0) {
                this.captchaCount -= 1
              } else {
                interval && clearInterval(interval)
              }
            }, 1000)
          }
        })
      } else {
        this.$message.error('手机号码错误')
      }
    },

    verificationCode () {
      const data = {
        captcha: this.form.captcha,
        uuid: this.form.uuid
      }
      return new Promise((resolve,reject)=>{
        $post('/merchant/verifyPhoneAndCode',data).then(r => {
          if (r.data && r.code === 200) {
            resolve(true)
          }else{
            reject(err)
          }
        }).catch (err =>{ 
          reject(err)
        })
      })
     
    }
  }
}
</script>

<style lang="scss" scoped>
.el-container {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 768px;
  min-width: 1024px;
  zoom: 1;
  background-size: cover;
  background: linear-gradient(#4796FC, #4784F5);
  background-repeat: no-repeat;
}

.el-main {
  height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}

.el-card {
  width: 80vw;
  height: 65vh;
  padding: 50px 60px;
  border: none;
  border-radius: 0;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  max-width: 1400px;
  max-height: 900px;
  min-height: 580px;
  min-width: 900px;

  .el-form {
    width: 500px;

    /deep/ {
      .el-form-item__label {
        font-weight: bold;
        font-size: 18px;
        position: relative;
        padding-left: 10px;

        &::before {
          position: absolute;
          left: 0;
        }
      }

      input {
        box-shadow: 0 2px 6px 0 rgba(88, 88, 88, 0.1);
      }
    }
  }
}

.form-title {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.title-wrapper {
  position: absolute;
  top: -60px;
  width: 384px;
  left: 50%;
  transform: translate(-50%, 0);
  user-select: none;
  text-align: center;

  span {
    display: block;
  }

  .title {
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: #fff;
    line-height: 24px;
  }
}

.el-steps {
  height: 80px;
}

.result {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  margin: 200px 0;
}

.item-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  p {
    line-height: 1em;
  }
}
</style>
